import * as getters from './getters';
import * as actions from './actions';
import * as mutations from './mutations';

export default{
    state:{
        actors:[],
        producers:[]
    },
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/modules/persons/store/index.js